export const openLoginLayer = () => {
    const tabletAppLink = document.getElementById(
        'c24-travel-tabletapp-customer-login-link'
    );
    if (tabletAppLink) {
        tabletAppLink.click();
    }
    const evt = new CustomEvent('unifiedLoginLayer.open', {
        detail: {
            fromChatbot: false,
            resetButtonSpinner: false,
        },
    });
    document.dispatchEvent(evt);
};
